import React, { memo } from 'react';
import { Skeleton } from 'site-modules/shared/components/skeleton/skeleton';

import './extract-skeleton.scss';

export const ExtractSkeleton = memo(() => (
  <div className="extract-skeleton base-inner-width pb-0_75 pb-md-1 mx-md-auto">
    <Skeleton className="d-block w-35 height-24 rounded-6 mb-1" />
    <Skeleton className="d-block w-30 height-22 rounded-6 mb-1 mb-md-0_75" />
    <Skeleton className="d-block w-60 height-22 rounded-6 mb-1 mb-md-0_75" />
    <Skeleton className="d-block w-50 height-22 rounded-6 mb-1 mb-md-0_75" />
  </div>
));

ExtractSkeleton.displayName = 'ExtractSkeleton';
